/* Fiche produit — Configurateur Perlé.
   Chargé uniquement sur les pages produit depuis layout/theme.liquid.

   Règles structurantes :
   - aucun prix n'est écrit en dur : tout est dérivé des variantes Shopify ;
   - la livraison gratuite est une règle panier : elle n'est pas calculée ici ;
   - l'axe de variante VIDEO n'existe plus (voir docs/00_SOURCE_OF_TRUTH.md). */
(() => {
  /* Lot 109 (A-30) — même convention que `snippets/sbc-prix.liquid` :
     suffixe, virgule, espace normale. `Intl.NumberFormat` produit une espace
     insécable qui ne correspond pas au prix rendu par Liquid au chargement
     (SSR), et écrasait un prix correctement formaté par un autre qui ne
     l'était pas au premier appel de `updateVariant()`. */
  const money = (cents) => (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';

  /* Même montant sans ses décimales nulles — la forme rendue par Liquid
     (`money_without_trailing_zeros`) pour le badge d'économie : « 3 € »,
     « 4,99 € ». Dérivée de `money`, pour qu'il n'existe qu'un seul format. */
  const moneyCourt = (cents) => money(cents).replace(/,00 €$/, ' €');

  /* Nombre de scoops d'une variante. Depuis le lot 102, le compte n'est plus
     réécrit ici : il vient de `assets/sbc-compte-scoops.js`, la seule source du
     thème, celle que le moteur de cadeaux et le test Node utilisent aussi. */
  const COMPTE = window.SbcCompteScoops || null;
  const scoopCount = (variant) => (COMPTE ? COMPTE.scoopsDeLaLigne(variant) : 0);

  /* Ce que contient une taille, lu entre les parenthèses de son libellé
     (« 1 Scoop (15–18 articles) » → « 15–18 articles »). Lot 145 : l'unité fait
     partie du libellé d'Alban, elle n'est plus rognée ni recollée ailleurs —
     le résumé d'étape et la carte rendaient « 15–18 articles) articles ». */
  const articlesRange = (sizeValue) => {
    const match = /\(([^)]*)\)/.exec(sizeValue || '');
    return match ? match[1].replace('/', ' à ').trim() : '';
  };

  /* Galerie : un seul geste pour activer un média, qu'il vienne du clic sur
     une vignette ou d'une variante dont le `featured_media` diffère du média
     déjà affiché. Même mécanisme partout : `is-active` sur le média et sur
     la vignette, `aria-pressed` sur la vignette, et le recentrage de la
     piste mobile (`scrollTo`) — inerte sur desktop où la piste ne défile
     pas. */
  const activerMedia = (gallery, mediaId) => {
    if (!gallery || mediaId == null) return;
    const id = String(mediaId);
    const medias = Array.from(gallery.querySelectorAll('[data-media-id]'));
    const index = medias.findIndex((media) => media.dataset.mediaId === id);
    if (index === -1) return;
    /* Complément de clôture de vague (5/09/2026) — Liquid pose déjà `is-active`
       sur le média de la variante courante : quand le média visé est celui qui
       est affiché, il n'y a rien à basculer et surtout aucune piste à faire
       défiler. Sans cette sortie, le boot rejouait le geste et déplaçait la
       galerie mobile sous les doigts de la cliente. */
    if (medias[index].classList.contains('is-active')) return;
    medias.forEach((media) => media.classList.toggle('is-active', media.dataset.mediaId === id));
    gallery.querySelectorAll('[data-media-target]').forEach((thumb) => {
      const active = thumb.dataset.mediaTarget === id;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', String(active));
    });
    positionnerPiste(gallery, index);
  };

  /* Piste mobile : elle démarre toujours à gauche, quel que soit le média actif
     rendu par Liquid. On la place sans animation — au boot il n'y a pas de
     geste à accompagner, et sur desktop la piste ne défile pas. */
  const positionnerPiste = (gallery, index) => {
    const track = gallery.querySelector('[data-gallery-track]');
    if (track) track.scrollTo({ left: index * track.clientWidth, behavior: 'auto' });
  };

  const indexMediaActif = (gallery) => {
    if (!gallery) return -1;
    return Array.from(gallery.querySelectorAll('[data-media-id]'))
      .findIndex((media) => media.classList.contains('is-active'));
  };

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const json = document.getElementById(root.dataset.productJson);
    const form = root.querySelector('[data-product-form]');
    if (!json || !form) return;
    const visibleOptions = root.hasAttribute('data-sbc-visible-options');

    const inventoryJson = document.getElementById(root.dataset.productInventory);
    const inventory = inventoryJson ? JSON.parse(inventoryJson.textContent) : {};
    const variants = JSON.parse(json.textContent).map((variant) => ({ ...variant, ...inventory[variant.id] }));
    const idInput = form.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-price]');
    const add = form.querySelector('[data-add-button]');
    const label = form.querySelector('[data-add-label]');
    const status = form.querySelector('[data-product-status]');
    const gallery = root.querySelector('[data-gallery]');
    const stockMeter = root.querySelector('[data-sbc-stock-meter]');
    /* R1 (constat B, A-04) — même garde que `snippets/sbc-prix.liquid` : un
       prix à 0 (SCOOP SKINCARE/MAKEUP notamment) ne s'affiche jamais comme
       « 0,00 € ». Le repli vient du réglage `prix_indisponible`, publié en
       attribut par `sections/main-product.liquid` (data-product-root). */
    const prixIndisponible = root.dataset.prixIndisponible || 'Prix bientôt disponible';
    const prixAffiche = (cents) => (Number(cents || 0) > 0 ? money(cents) : prixIndisponible);
    /* La barre mobile est rendue HORS de .product-page : voir le commentaire de
       sections/main-product.liquid (backdrop-filter et bloc conteneur). */
    const scope = root.closest('.shopify-section') || document;
    const mobileBar = scope.querySelector('[data-mobile-product-bar]');
    const mobilePrice = scope.querySelector('[data-mobile-price]');
    const mobileConfig = scope.querySelector('[data-mobile-config]');
    const mobileAdd = scope.querySelector('[data-mobile-add]');
    const mobileAddLabel = scope.querySelector('[data-mobile-add-label]');
    /* Lot 107 — `[data-articles-note]` et `[data-summary]` ne sont plus rendus
       par `sections/main-product.liquid` : la micro-promesse ne répète plus la
       quantité d'articles (elle est dans le choix de taille) et le
       récapitulatif « Inclus dans votre scoop » a disparu avec l'« enhancer »
       qui le retirait du DOM à chaque chargement. Le code qui les écrivait est
       parti avec eux. */
    /* Lot 145 — l'add-on vidéo de la fiche (`[data-video-addon]`, sa case et
       son repère « déjà au panier ») n'existe plus : la vidéo est un axe
       d'option des scoops, choisi dans son bandeau et vendu dans la même ligne
       de panier. Le code qui pilotait la case est parti avec elle. */

    /* Le seuil vient de la même source que le panier :
       `snippets/sbc-cadeaux-config.liquid`. Le réécrire ici en dur ferait
       diverger la fiche produit du panier. Il se compte en scoops, jamais en
       euros (lot 102, `CLAUDE.md` § 3) ; le palier en montant qui l'accompagnait
       — le carnet offert — est retiré par la décision D19 (lot 147). */
    let CADEAUX = {};
    try {
      const noeud = document.querySelector('[data-sbc-cadeaux-config]');
      if (noeud) CADEAUX = JSON.parse(noeud.textContent) || {};
    } catch (_) { CADEAUX = {}; }
    /* Lot 146 — la fiche ne lit pas l'état du panier pour décider de la vidéo :
       l'axe « VIDÉO TIKTOK » est un choix de variante, et son supplément est la
       différence de prix entre les deux variantes de la MÊME taille. Tout ce
       qu'elle affiche se déduit donc de la sélection en cours. */
    /* Triés par position d'option Shopify : l'index d'un groupe doit
       correspondre à l'index dans variant.options, indépendamment de
       l'ordre d'affichage choisi dans le balisage. */
    const groups = [...form.querySelectorAll('[data-option-position]')]
      .sort((a, b) => parseInt(a.dataset.optionPosition, 10) - parseInt(b.dataset.optionPosition, 10));
    const sizeGroup = form.querySelector('.pdp-cards--size:not([data-gloss-formats])')?.closest('[data-option-position]') || null;
    const goldGroup = form.querySelector('.pdp-cards--gold')?.closest('[data-option-position]') || null;
    /* Lot 145 — troisième axe : la vidéo de préparation. Le groupe est repéré
       par sa liste de cartes, comme les deux autres ; son fieldset porte le
       libellé de sa valeur « sans vidéo » (`data-video-sans`), écrit par le
       Liquid. Le script ne le fabrique pas : il le relit. Lot 151 (D20) — il
       ne coche de lui-même que là où Shopify ne laisse plus le choix, et
       n'écrit toujours aucun libellé : les textes viennent des réglages. */
    const videoGroup = form.querySelector('.pdp-cards--video')?.closest('[data-option-position]') || null;
    const videoSans = videoGroup?.dataset.videoSans
      || videoGroup?.querySelector('input[data-video-value]')?.value
      || '';
    /* Lot 151 (D20) — l'autre valeur de l'axe, quelle qu'elle soit : le script
       ne connaît toujours aucun libellé, il lit ce que Shopify publie. */
    const videoRadios = () => (videoGroup
      ? [...videoGroup.querySelectorAll('input[data-video-value]')]
      : []);
    const videoAvec = videoRadios().map((input) => input.value).find((valeur) => valeur !== videoSans) || '';
    const videoInputDe = (valeur) => videoRadios().find((input) => input.value === valeur) || null;

    /* Lot 140 — deux lectures de la sélection, qui ne se confondent jamais.

       `repli: true` remplace un axe non coché par sa première valeur : les
       cartes doivent afficher un prix dès l'arrivée sur la fiche, sans que ce
       prix devienne une sélection. `repli: false` dit ce que la cliente a
       réellement choisi — un axe vide y reste vide, et aucune variante n'est
       résolue tant qu'il l'est. Confondre les deux, c'est vendre une box que
       personne n'a demandée. */
    const selectedValues = (repli) => groups.map((group) => {
      const checked = group.querySelector('input:checked');
      if (checked) return checked.value;
      return repli ? (group.querySelector('input[data-option-value]')?.value || '') : '';
    });
    const indexOf = (group) => groups.indexOf(group);

    /* Variante correspondant à la sélection courante, en remplaçant
       éventuellement la valeur d'un seul axe (utilisé pour chiffrer une carte
       qui n'est pas encore sélectionnée).

       Produits mono-variante (Pochette, vidéo de préparation) : la section ne rend
       aucun groupe d'options — leur unique axe Shopify vaut « Default Title ».
       `selectedValues()` renvoyait alors [] et la comparaison
       `'Default Title' === undefined` échouait : le CTA affichait
       « Combinaison indisponible » et l'achat était impossible.
       Sans axe rendu, la seule variante existante fait foi. */
    /* Lot 145 — plusieurs axes peuvent être forcés à la fois : chiffrer
       l'économie d'un pack demande de fixer la taille ET la vidéo (sans quoi
       le supplément vidéo serait compté deux fois d'un côté du calcul). */
    const variantePour = (overrides) => {
      if (!groups.length) return variants[0];
      const values = selectedValues(true);
      (overrides || []).forEach(([group, value]) => {
        const i = group ? indexOf(group) : -1;
        if (i >= 0) values[i] = value;
      });
      return variants.find((item) => item.options.every((value, index) => value === values[index]));
    };
    const findVariant = (overrideGroup, overrideValue) => (
      variantePour(overrideGroup ? [[overrideGroup, overrideValue]] : [])
    );

    /* La variante RÉELLEMENT choisie, ou `null` tant qu'un axe attend sa
       réponse. Un produit sans axe rendu (Pochette, vidéo de préparation)
       n'attend rien : son unique variante fait foi, comme dans `findVariant`. */
    /* Lot 144 — « il manque une réponse » se mesure sur les GROUPES d'options,
       jamais sur un axe nommé : le jour où un axe s'ajoute (Vidéo, lot 145),
       il entre dans le « + » et dans la mécanique des bandeaux sans une ligne
       de code de plus. */
    const optionsIncompletes = () => groups.length > 0
      && groups.some((group) => !group.querySelector('input:checked'));

    const variantSelectionnee = () => {
      if (!groups.length) return variants[0];
      if (optionsIncompletes()) return null;
      const values = selectedValues(false);
      return variants.find((item) => item.options.every((value, index) => value === values[index]));
    };

    /* --- Lot 151 (D20) : la vidéo offerte se lit dans les variantes ---------

       Aucun seuil, aucun comptage de scoops. La question posée est toujours la
       même : « pour la formule que la cliente a choisie, Shopify vend-il encore
       la variante SANS vidéo ? ». Si non — et si la variante AVEC se vend —,
       la vidéo est comprise dans le prix : le script la coche, retire le choix
       et le bandeau affiche son état d'information.

       `selectedValues(false)` et non le repli : tant qu'un axe attend sa
       réponse, rien n'est offert ni annoncé. C'est la règle du lot 140, et
       c'est ce qui empêche la fiche de promettre une gratuité avant que la
       cliente ait dit ce qu'elle veut.

       Le rendu serveur applique la même règle sur `current_variant`
       (`sections/main-product.liquid`) : les deux lisent la même source. */
    const varianteVideo = (valeur) => {
      if (!videoGroup || !valeur) return null;
      const position = indexOf(videoGroup);
      if (position < 0) return null;
      const values = selectedValues(false);
      values[position] = valeur;
      if (values.some((value) => !value)) return null;
      return variants.find((item) => item.options.every((value, index) => value === values[index])) || null;
    };
    const videoIncluse = () => {
      const sans = varianteVideo(videoSans);
      const avec = varianteVideo(videoAvec);
      return Boolean(videoGroup?.hasAttribute('data-video-offerte-resume')
        && sans && avec && sans.price > 0 && sans.price === avec.price
        && sans.available === false && avec.available === true);
    };

    /* Le choix fait à la main par la cliente, retenu pour lui être rendu si la
       formule redevient payante. `videoImposee` distingue ce que le script a
       coché de ce qu'elle a coché : on ne défait jamais son geste à elle. */
    let videoChoixManuel = '';
    let videoImposee = false;
    const syncVideoIncluse = () => {
      if (!videoGroup || !videoAvec) return;
      const inputSans = videoInputDe(videoSans);
      const inputAvec = videoInputDe(videoAvec);
      if (videoIncluse()) {
        if (inputSans) { inputSans.checked = false; inputSans.disabled = true; }
        if (inputAvec) inputAvec.checked = true;
        videoGroup.setAttribute('data-video-incluse', '');
        videoImposee = true;
        return;
      }
      if (inputSans) inputSans.disabled = false;
      videoGroup.removeAttribute('data-video-incluse');
      if (!videoImposee) return;
      videoImposee = false;
      /* Retour vers une formule payante : la sélection d'office s'annule, et
         le choix antérieur revient s'il existait — sinon rien n'est coché, et
         « Vidéo » redevient le bandeau en attente (D17 Q6, lot 148). */
      const coche = videoGroup.querySelector('input[data-video-value]:checked');
      if (!coche || coche.value !== videoAvec) return;
      coche.checked = false;
      const retour = videoChoixManuel ? videoInputDe(videoChoixManuel) : null;
      if (retour) retour.checked = true;
    };

    /* Lot 145 — l'attente ne nomme plus d'axe. Le premier groupe sans réponse,
       dans l'ordre `data-option-position`, donne le libellé du bouton : son
       bandeau le porte dans `data-step-cta`, écrit en Liquid. Un axe ajouté
       demain entre dans le parcours sans une ligne de code de plus. */
    const groupeEnAttente = () => groups.find((group) => !group.querySelector('input:checked')) || null;
    const typeDeChoix = (group) => {
      if (group?.dataset.sbcChoiceKind) return group.dataset.sbcChoiceKind;
      if (group === goldGroup || group?.dataset.optionName?.includes('gold')) return 'gold';
      if (group === videoGroup || group?.dataset.optionName?.includes('vid')) return 'video';
      return 'size';
    };
    const libelleAttente = () => {
      const group = groupeEnAttente();
      const step = group ? group.closest('[data-step]') : null;
      const fallback = typeDeChoix(group) === 'video' ? 'Choisissez votre option vidéo'
        : group?.hasAttribute('data-sbc-size-buttons') ? 'Choisissez votre format' : 'Choisissez vos options';
      return (step && step.dataset.stepCta) || (group && group.dataset.stepCta) || fallback;
    };
    const ATTENTE_RESUME = 'Sélectionner une option';
    /* Prix mini réellement achetable : variantes disponibles au prix positif,
       éventuellement bornées à une taille. Même règle que la boucle Liquid qui
       rend le montant suivi de son « + » au chargement (lot 144) — les deux
       doivent annoncer le même montant, sinon le prix changerait tout seul à
       l'exécution du script.
       `product.price_min` ne convenait pas : il compte aussi les variantes
       épuisées, que la cliente ne peut pas acheter. */
    /* Lot 145 — le minimum est borné par TOUS les axes déjà répondus, plus
       seulement par la taille. Avec trois axes, un minimum calculé sur la seule
       taille redescendait sous le prix atteignable dès qu'une GOLD était
       choisie (mesuré : « 2 Scoops » + « + 4 perles GOLD » annonçait 63,00 €+
       quand le moins cher encore accessible valait 73,00 €) — un montant
       périmé, donc trop bas, ce qu'aucun prix affiché n'a le droit d'être. */
    const prixMini = () => {
      const values = groups.map((group) => group.querySelector('input:checked')?.value || null);
      const compatible = variants.filter((item) => item.price > 0
        && values.every((value, index) => value === null || item.options[index] === value));
      const available = compatible.filter((item) => item.available);
      // A sold-out scoop still has a real price; this fallback never makes it purchasable.
      const candidates = available.length ? available : (visibleOptions ? compatible : []);
      return candidates.reduce((mini, item) => mini === 0 || item.price < mini ? item.price : mini, 0);
    };
    /* Lot 144 (D18) — le prix s'écrit en morceaux, jamais en une chaîne : le
       montant seul porte le nombre, le « + » vit à côté et reste `aria-hidden`,
       et un texte `sr-only` dit ce qu'il signifie. C'est exactement le balisage
       de `snippets/sbc-prix-plus.liquid` : le serveur et le script doivent
       rendre le même nœud, sinon le prix changerait de forme à l'exécution.
       Un montant non positif retombe sur la garde de prix — un repli n'est pas
       un minimum, il ne prend donc pas de « + ». */
    const ecrirePrix = (node, cents, suffixe) => {
      if (!node) return;
      const valeur = Number(cents || 0);
      node.textContent = '';
      const montant = document.createElement('span');
      montant.className = 'pdp-prix__montant';
      montant.textContent = valeur > 0 ? money(valeur) : prixIndisponible;
      node.appendChild(montant);
      if (!suffixe || valeur <= 0) return;
      const plus = document.createElement('span');
      plus.className = 'pdp-prix__plus';
      plus.setAttribute('aria-hidden', 'true');
      plus.textContent = '+';
      node.appendChild(plus);
      const dit = document.createElement('span');
      dit.className = 'sr-only';
      dit.textContent = ' au minimum, selon les options choisies';
      node.appendChild(dit);
    };

    /* --- Cartes de taille : prix, prix/scoop, badge d'économie et avantages -

       Complément de clôture de vague (5 septembre 2026) — le badge suit
       désormais les prix affichés.

       `snippets/pdp-size-card.liquid` chiffre l'économie sur les variantes
       NORMAL, alors que ces mêmes cartes affichent les prix du GOLD choisi :
       après « +1 GOLD » sur la Papeterie, les prix passaient à 36/66/96/126 €
       pendant que le badge disait encore « −3 € » là où l'écart réel vaut
       6 €. Jamais une remise gonflée, mais un montant qui ne correspondait
       plus aux prix qui l'entourent. Il est donc recalculé sur les variantes
       du GOLD courant : (prix d'un scoop × n) − prix du pack de n. Aucun
       montant n'est écrit en dur ; si l'écart n'est plus positif ou si un
       prix manque, le badge disparaît plutôt que d'annoncer un faux. */
    const updateSavingDetail = (card, saving, count, unit, pack) => {
      if (!visibleOptions) return;
      const choice = card.closest('.sbc-choice');
      const button = choice?.querySelector('[data-saving-button]');
      if (!button) return;
      const amount = moneyCourt(saving);
      button.setAttribute('aria-label', button.dataset.labelTemplate.replace('[amount]', amount));
      choice.querySelector('[data-saving-amount]').textContent = amount;
      choice.querySelector('[data-saving-calculation]').textContent = `${count} × ${money(unit)} − ${money(pack)} = ${amount}`;
    };

    const refreshSizeCards = () => {
      if (!sizeGroup) return;
      const inputs = [...sizeGroup.querySelectorAll('input[data-size-value]')];
      /* Référence unitaire : la carte « 1 scoop », chiffrée avec le GOLD
         courant — exactement la variante que la cliente paierait. */
      const unitInput = inputs.find((item) => parseInt(item.dataset.scoopCount || '0', 10) === 1);
      /* Lot 145 — le BADGE se calcule à vidéo égale, sur la valeur « sans » :
         l'écart (prix d'un scoop × n) − prix du pack de n compte sinon le
         supplément vidéo n fois d'un côté et une seule de l'autre, et la carte
         « 2 scoops » annonçait 18 € d'économie là où le pack en fait gagner 3.
         Les PRIX affichés, eux, suivent la vidéo choisie : c'est ce que la
         cliente paiera. */
      const varianteSansVideo = (sizeValue) => {
        const overrides = [[sizeGroup, sizeValue]];
        if (videoGroup) overrides.push([videoGroup, videoSans]);
        if (visibleOptions && goldGroup) overrides.push([goldGroup, goldGroup.querySelector('input').value]);
        return variantePour(overrides);
      };
      const unitSansVideo = unitInput ? varianteSansVideo(unitInput.value) : null;
      inputs.forEach((input) => {
        const card = input.nextElementSibling;
        if (!card) return;
        const variant = visibleOptions ? varianteSansVideo(input.value) : findVariant(sizeGroup, input.value);
        const count = parseInt(input.dataset.scoopCount || '0', 10);
        const priceEl = card.querySelector('[data-card-price]');
        const unitEl = card.querySelector('[data-card-unit]');
        const savingEl = card.querySelector('.pdp-card__saving') || (visibleOptions ? card.parentElement.querySelector('[data-saving-button]') : null);
        if (variant) {
          if (priceEl) priceEl.textContent = prixAffiche(variant.price);
          if (unitEl && count > 0) {
            unitEl.textContent = variant.price > 0 ? `${money(Math.round(variant.price / count))} / scoop` : '';
          }
        }
        if (savingEl) {
          const packSansVideo = varianteSansVideo(input.value);
          const prixConnus = Boolean(packSansVideo) && Boolean(unitSansVideo)
            && packSansVideo.price > 0 && unitSansVideo.price > 0;
          const ecart = prixConnus ? unitSansVideo.price * count - packSansVideo.price : 0;
          const montre = count > 1 && ecart >= 1;
          savingEl.hidden = !montre;
          if (montre) {
            const montant = moneyCourt(ecart);
            savingEl.textContent = `−${montant}`;
            savingEl.setAttribute('aria-label', `Économie de ${montant}`);
            card.dataset.sbcSaving = String(ecart);
            updateSavingDetail(card, ecart, count, unitSansVideo.price, packSansVideo.price);
          } else {
            /* L'attribut porte les réserves d'espace du badge dans la feuille
               (`[data-sbc-saving]`) : il part avec lui. */
            card.removeAttribute('data-sbc-saving');
          }
        }
      });
    };

    /* --- Cartes GOLD : supplément dérivé des variantes, et badge d'économie -

       Lot 140 — le badge des cartes de taille dit « ce pack vous fait
       économiser tant » ; les paliers GOLD ont la même dégressivité et ne le
       disaient nulle part. L'écart se calcule sur les variantes du GOLD
       courant, exactement comme le supplément juste au-dessus : (supplément
       d'UNE perle × n) − supplément du palier de n perles. Aucun montant écrit
       en dur ; un palier proportionnel (deux perles au double du prix d'une)
       n'affiche rien, et un prix manquant fait disparaître le badge plutôt que
       d'annoncer un faux. Le nœud du badge n'existe que si le rendu serveur l'a
       posé : sans lui on ne peut rien montrer, ce qui reste sans danger. */
    const refreshGoldCards = () => {
      if (!goldGroup) return;
      const inputs = [...goldGroup.querySelectorAll('input[data-gold-value]')];
      const baseVariant = inputs[0] ? findVariant(goldGroup, inputs[0].value) : null;
      if (!baseVariant) return;
      /* Référence unitaire : le palier à UNE perle, chiffré sur la taille
         courante — la même perle que la cliente paierait. */
      const unInput = inputs.find((item) => parseInt(item.dataset.goldCount || '0', 10) === 1);
      const unVariant = unInput ? findVariant(goldGroup, unInput.value) : null;
      const deltaUn = unVariant && unVariant.price > 0 ? unVariant.price - baseVariant.price : 0;
      inputs.forEach((input) => {
        const card = input.nextElementSibling;
        if (!card) return;
        const supplementEl = card.querySelector('[data-gold-supplement]');
        const savingEl = card.querySelector('.pdp-card__saving') || (visibleOptions ? card.parentElement.querySelector('[data-saving-button]') : null);
        const variant = findVariant(goldGroup, input.value);
        const count = parseInt(input.dataset.goldCount || '0', 10);
        const delta = variant ? variant.price - baseVariant.price : 0;
        if (visibleOptions) {
          if (variant) card.dataset.sbcSupplement = String(delta);
          else delete card.dataset.sbcSupplement;
        }
        if (supplementEl && variant) supplementEl.textContent = delta > 0 || visibleOptions ? `+${money(delta)}` : '';
        if (!savingEl) return;
        const ecart = variant && deltaUn > 0 && delta > 0 ? deltaUn * count - delta : 0;
        const montre = count > 1 && ecart >= 1;
        savingEl.hidden = !montre;
        if (montre) {
          const montant = moneyCourt(ecart);
          savingEl.textContent = `−${montant}`;
          savingEl.setAttribute('aria-label', `Économie de ${montant}`);
          card.dataset.sbcSaving = String(ecart);
          updateSavingDetail(card, ecart, count, deltaUn, delta);
        } else {
          /* L'attribut porte la réserve d'espace du badge dans la feuille
             (`[data-sbc-saving]`) : il part avec lui. */
          card.removeAttribute('data-sbc-saving');
        }
      });
    };

    /* --- Cartes « Vidéo » : supplément dérivé des variantes (lot 145) -------

       La vidéo est un axe d'option des scoops : son prix n'existe nulle part
       en tant que montant, il est la DIFFÉRENCE entre la variante portant
       « AVEC » et celle portant « SANS », toutes autres options égales.

       Lot 151 (D20) — la carte affiche le supplément réel, et rien du tout
       s'il est nul. Elle n'annonce jamais de gratuité : là où la vidéo est
       comprise dans le prix, ce sont les deux cartes qui s'effacent derrière
       le bloc d'état, et `verif-video-variantes.test.mjs` vérifie que l'écart
       y vaut bien zéro. */
    const refreshVideoCards = () => {
      if (!videoGroup) return;
      const base = variantePour([[videoGroup, videoSans]]);
      [...videoGroup.querySelectorAll('input[data-video-value]')].forEach((input) => {
        const card = input.nextElementSibling;
        const cible = card ? card.querySelector('[data-video-supplement]') : null;
        if (!cible) return;
        if (input.value === videoSans) { cible.textContent = ''; return; }
        const variant = findVariant(videoGroup, input.value);
        if (!variant || !base || !(base.price > 0)) { cible.textContent = ''; return; }
        const delta = variant.price - base.price;
        /* D19 : la vidéo est payante. Un écart nul n'affiche rien — jamais une
           gratuité que les prix ne tiendraient pas (`CLAUDE.md` § 3). */
        cible.textContent = delta > 0 ? `+${money(delta)}` : '';
      });
    };

    // Palette and book choices use the same explicit radio flow as video.
    const refreshBinaryCards = () => {
      groups.filter((group) => group.hasAttribute('data-sbc-binary-options')).forEach((group) => {
        const inputs = [...group.querySelectorAll('input[data-option-value]')];
        const base = inputs[0] ? findVariant(group, inputs[0].value) : null;
        inputs.forEach((input) => {
          const output = input.nextElementSibling?.querySelector('[data-option-supplement]');
          if (!output) return;
          const variant = findVariant(group, input.value);
          const delta = base?.price > 0 && variant ? variant.price - base.price : 0;
          output.textContent = delta > 0 ? `+${money(delta)}` : '';
        });
      });
    };

    /* --- Résumés des étapes repliables -------------------------------------

       Lot 145 — la boucle parcourt TOUS les groupes d'options, quel que soit
       leur nombre : chaque bandeau replié dit ce qui y a été répondu. Les
       précisions propres à un axe (la fourchette d'articles d'une taille, le
       supplément d'une GOLD, celui d'une vidéo) s'ajoutent ensuite, et
       seulement quand le montant est réellement connu — un prix qui n'est pas
       résolu ne s'invente pas. */
    const refreshSelectionDetails = () => {
      if (!visibleOptions) return;
      const sizeDetail = form.querySelector('[data-sbc-size-detail]');
      const sizeInput = sizeGroup?.querySelector('input:checked');
      if (sizeDetail) {
        sizeDetail.hidden = !sizeInput;
        if (sizeInput) {
          const card = sizeInput.nextElementSibling;
          const count = Number(sizeInput.dataset.scoopCount || 0);
          const range = articlesRange(sizeInput.value).replace(' à ', '–');
          const rangeNode = sizeDetail.querySelector('[data-sbc-detail-range]');
          rangeNode.textContent = range ? sizeDetail.dataset.rangeTemplate.replace('[range]', range) : '';
          rangeNode.hidden = !range;
          const unit = sizeDetail.querySelector('[data-sbc-detail-unit]');
          unit.textContent = card?.querySelector('[data-card-unit]')?.textContent.trim() || '';
          unit.hidden = !unit.textContent;
          const totalNode = sizeDetail.querySelector('[data-sbc-detail-total]');
          if (totalNode) totalNode.textContent = card?.querySelector('[data-card-price]')?.textContent.trim() || '';
          const saving = Number(card?.dataset.sbcSaving || 0);
          const savingNode = sizeDetail.querySelector('[data-sbc-detail-saving]');
          savingNode.textContent = sizeDetail.dataset.savingTemplate.replace('[amount]', moneyCourt(saving));
          savingNode.hidden = saving <= 0;
          const sourceButton = card?.parentElement.querySelector('[data-saving-button]');
          const popoverId = sourceButton?.getAttribute('popovertarget');
          if (popoverId) savingNode.setAttribute('popovertarget', popoverId);
          else savingNode.removeAttribute('popovertarget');
          savingNode.hidden = saving <= 0 || !popoverId;
          savingNode.setAttribute('aria-label', sourceButton?.getAttribute('aria-label') || savingNode.textContent);
        }
      }
      const glossDetail = form.querySelector('[data-sbc-gloss-detail]');
      if (glossDetail) {
        const input = form.querySelector('[data-gloss-formats] input:checked');
        const card = input?.nextElementSibling;
        glossDetail.hidden = !card;
        if (card) {
          glossDetail.querySelector('[data-sbc-detail-total]').textContent = card.querySelector('[data-card-price]').textContent;
          glossDetail.querySelector('[data-sbc-detail-range]').textContent = card.querySelector('.pdp-card__meta').textContent;
          glossDetail.querySelector('[data-sbc-detail-unit]').textContent = card.querySelector('[data-card-unit]').textContent;
          const saving = Number(card.dataset.sbcSaving || 0);
          const button = card.parentElement.querySelector('[data-saving-button]');
          const savingNode = glossDetail.querySelector('[data-sbc-detail-saving]');
          const popoverId = button?.getAttribute('popovertarget');
          savingNode.textContent = glossDetail.dataset.savingTemplate.replace('[amount]', moneyCourt(saving));
          savingNode.hidden = saving <= 0 || !popoverId;
          if (popoverId) savingNode.setAttribute('popovertarget', popoverId);
          else savingNode.removeAttribute('popovertarget');
          savingNode.setAttribute('aria-label', button?.getAttribute('aria-label') || savingNode.textContent);
        }
      }
      const goldDetail = form.querySelector('[data-sbc-gold-detail]');
      if (goldDetail) {
        const input = goldGroup?.querySelector('input:checked');
        const card = input?.nextElementSibling;
        const supplement = Number(card?.dataset.sbcSupplement);
        const count = Number(input?.dataset.goldCount || 0);
        goldDetail.hidden = !input || !Number.isFinite(supplement);
        const total = goldDetail.querySelector('[data-sbc-gold-total]');
        if (total) total.textContent = Number.isFinite(supplement) ? `+${money(supplement)}` : '';
        const selected = goldDetail.querySelector('[data-sbc-gold-selected]');
        if (selected) selected.textContent = input?.dataset.label || '';
        const unit = goldDetail.querySelector('[data-sbc-gold-unit]');
        if (unit) {
          unit.hidden = count < 1 || !Number.isFinite(supplement);
          unit.textContent = count > 0 && Number.isFinite(supplement) ? goldDetail.dataset.unitTemplate.replace('[amount]', money(Math.round(supplement / count))) : '';
        }
        const saving = Number(card?.dataset.sbcSaving || 0);
        const savingNode = goldDetail.querySelector('[data-sbc-detail-saving]');
        const sourceButton = card?.parentElement.querySelector('[data-saving-button]');
        const popoverId = sourceButton?.getAttribute('popovertarget');
        savingNode.textContent = goldDetail.dataset.savingTemplate.replace('[amount]', moneyCourt(saving));
        if (popoverId) savingNode.setAttribute('popovertarget', popoverId);
        else savingNode.removeAttribute('popovertarget');
        savingNode.hidden = saving <= 0 || !popoverId;
        savingNode.setAttribute('aria-label', sourceButton?.getAttribute('aria-label') || savingNode.textContent);
      }
    };

    const refreshStepSummaries = (variant) => {
      refreshSelectionDetails();
      const sizeInput = sizeGroup?.querySelector('input:checked');
      const goldInput = goldGroup?.querySelector('input:checked');
      const videoInput = videoGroup?.querySelector('input:checked');

      /* Lot 140 — un axe sans réponse l'annonce, au lieu de garder le résumé
         d'une variante que personne n'a demandée. */
      groups.forEach((group) => {
        const input = group.querySelector('input:checked');
        const text = group.querySelector('[data-step-summary]');
        const value = group.querySelector('[data-step-value]');
        if (group.hasAttribute('data-sbc-compact-step')) group.classList.toggle('is-selected', Boolean(input));
        if (!input) {
          if (text) text.textContent = ATTENTE_RESUME;
          if (value) value.textContent = '';
          return;
        }
        /* Lot 144 — le bandeau se referme dès qu'on y répond : son résumé
           devient la seule trace visible de la réponse. Il ne peut donc pas
           attendre qu'une variante entière se résolve : à défaut, il porte le
           libellé de la carte choisie, et AUCUN montant. */
        if (text) text.textContent = input.dataset.label || input.value;
        if (value) value.textContent = '';
      });

      /* Le supplément vidéo est déjà calculé sur la carte cochée : le résumé
         le recopie plutôt que de le recalculer autrement, pour que le bandeau
         replié et la carte ne puissent jamais dire deux montants différents. */
      if (videoGroup && videoInput) {
        const value = videoGroup.querySelector('[data-step-value]');
        const text = videoGroup.querySelector('[data-step-summary]');
        if (videoGroup.hasAttribute('data-video-incluse')) {
          /* Lot 151 — la formule ne laisse plus de choix : le bandeau replié
             dit l'état, jamais le libellé de la variante, et aucun montant.
             Le texte vient du réglage de section, relu sur le bandeau. */
          const resume = videoGroup.dataset.videoOfferteResume;
          if (text && resume) text.textContent = resume;
          if (value) value.textContent = '';
        } else {
          const carte = videoInput.nextElementSibling;
          const supplement = carte ? carte.querySelector('[data-video-supplement]') : null;
          if (value) value.textContent = supplement ? supplement.textContent.trim() : '';
        }
      }

      if (!variant) return;

      if (sizeGroup && sizeInput) {
        const count = scoopCount(variant);
        /* Forme courte « 30–36 articles » : elle vient du libellé Shopify, son
           unité comprise, et rien ne s'y ajoute (lot 145). */
        const range = articlesRange(sizeInput.value).replace(' à ', '–');
        const text = sizeGroup.querySelector('[data-step-summary]');
        const value = sizeGroup.querySelector('[data-step-value]');
        if (text) text.textContent = `${count} scoop${count > 1 ? 's' : ''}${range && !sizeGroup.hasAttribute('data-sbc-compact-step') ? ` · ${range}` : ''}`;

        /* 01/10/2026 — le bandeau « Taille du scoop » affiche uniquement le
           prix de base de la taille choisie. GOLD et Vidéo gardent leurs
           suppléments sur leurs propres bandeaux ; afficher ici le prix de la
           variante complète donnait visuellement l'impression de les compter
           une seconde fois (ex. 58 € + 10 € + 15 €).
           Base = taille choisie + premier niveau GOLD (NORMAL) + SANS Vidéo.
           Le Scoop Skincare n'a pas d'axe GOLD : le même calcul fonctionne. */
        const baseOverrides = [[sizeGroup, sizeInput.value]];
        if (goldGroup) {
          const goldNeutre = goldGroup.querySelector('input[data-gold-value]')?.value || '';
          if (goldNeutre) baseOverrides.push([goldGroup, goldNeutre]);
        }
        if (videoGroup && videoSans) baseOverrides.push([videoGroup, videoSans]);
        const varianteBaseTaille = variantePour(baseOverrides);
        if (value) value.textContent = varianteBaseTaille ? prixAffiche(varianteBaseTaille.price) : '';
      }

      if (goldGroup && goldInput) {
        const first = goldGroup.querySelector('input[data-gold-value]');
        const baseVariant = first ? findVariant(goldGroup, first.value) : null;
        const value = goldGroup.querySelector('[data-step-value]');
        if (value && baseVariant) {
          const delta = variant.price - baseVariant.price;
          value.textContent = delta > 0 || visibleOptions ? `+${money(Math.max(0, delta))}` : '';
        }
      }
    };

    /* --- Stock produit ------------------------------------------------------ */
    const refreshStockMeter = (variant) => {
      if (!stockMeter) return;

      const raw = variant ? Number(variant.inventory_quantity) : Number(stockMeter.dataset.stockTotal);
      const stock = Number.isFinite(raw) ? Math.max(0, raw) : 0;
      const tracked = variant
        ? Boolean(variant.inventory_management) && Number.isFinite(raw)
        : stockMeter.dataset.stockTotalTracked === 'true';
      const available = variant ? variant.available : stockMeter.dataset.stockTotalAvailable === 'true';
      const onOrder = variant ? variant.inventory_policy === 'continue' : stockMeter.dataset.stockTotalOnOrder === 'true';
      const labels = stockMeter.dataset;
      let level = 100;
      let className = 'sbc-stock-meter--high';
      let labelStock = labels.stockLabelAvailable;

      if (!available || (tracked && stock === 0)) {
        level = 0;
        className = 'sbc-stock-meter--out';
        labelStock = available && onOrder ? labels.stockLabelOnOrder : labels.stockLabelOut;
      } else if (tracked) {
        if (stock <= 2) {
          level = 22;
          className = 'sbc-stock-meter--critical';
          labelStock = labels.stockLabelLow;
        } else if (stock <= 5) {
          level = 45;
          className = 'sbc-stock-meter--low';
          labelStock = labels.stockLabelLow;
        } else if (stock <= 9) {
          level = 72;
          className = 'sbc-stock-meter--medium';
        }
      }

      const initialValue = variant ? Number(variant.initial_stock ?? 0) : Number(labels.stockInitialTotal || 0);
      const initial = Math.max(0, Number.isFinite(initialValue) ? initialValue : 0);
      const lowPercentage = Number(labels.stockLowPercentage || 0);
      const referenceRequired = labels.stockReferenceRequired === 'true';
      const showTrack = tracked && (!referenceRequired || initial > 0);
      if (tracked && initial > 0) {
        level = Math.round(Math.min(100, (available ? stock : 0) * 100 / initial) * 100) / 100;
        if (available && stock > 0) {
          className = level <= 10 ? 'sbc-stock-meter--critical'
            : level <= 25 ? 'sbc-stock-meter--low'
            : level <= 50 ? 'sbc-stock-meter--medium'
            : 'sbc-stock-meter--high';
          if (lowPercentage > 0 && level <= lowPercentage) labelStock = labels.stockLabelLow;
        }
      }

      if (referenceRequired && initial === 0) level = 0;
      stockMeter.dataset.stockInitial = String(initial);

      ['sbc-stock-meter--high','sbc-stock-meter--medium','sbc-stock-meter--low','sbc-stock-meter--critical','sbc-stock-meter--out']
        .forEach((name) => stockMeter.classList.remove(name));
      stockMeter.classList.add(className);
      stockMeter.dataset.stockQuantity = String(available ? stock : 0);

      const labelNode = stockMeter.querySelector('[data-sbc-stock-label]');
      const fillNode = stockMeter.querySelector('[data-sbc-stock-fill]');
      const trackNode = stockMeter.querySelector('.sbc-stock-meter__track');
      if (labelNode) labelNode.textContent = labelStock;
      if (fillNode) fillNode.style.setProperty('--sbc-stock-level', `${level}%`);
      if (trackNode) trackNode.hidden = !showTrack;
      stockMeter.setAttribute('aria-label', labelStock);
    };

    /* --- Barre mobile : contenu -------------------------------------------- */
    const refreshSticky = (variant) => {
      /* Lot 144 — la barre mobile porte le MÊME nœud de prix que la colonne
         d'achat : une variante résolue s'y affiche sans « + », et l'absence de
         variante y retombe sur la garde de prix. */
      ecrirePrix(mobilePrice, variant ? variant.price : 0, false);
      if (!mobileConfig) return;
      /* Lot 145 — le résumé collant suit les axes rendus, quel qu'en soit le
         nombre : « 2 scoops · + 1 perle GOLD · AVEC Vidéo ». Seul le premier
         niveau de GOLD reste tu — « Aucune GOLD supplémentaire » n'apprend
         rien à qui lit une barre de 390px de large. */
      const parts = [];
      groups.forEach((group) => {
        const input = group.querySelector('input:checked');
        if (!input) return;
        if (group === goldGroup && input.value === goldGroup.querySelector('input')?.value) return;
        parts.push(input.dataset.label || input.value);
      });
      mobileConfig.textContent = parts.join(' · ') || ' ';
    };

    /* --- Sélection courante ------------------------------------------------ */
    const updateVariant = () => {
      /* Lot 151 — l'état de la vidéo se règle AVANT toute lecture : c'est lui
         qui peut cocher « AVEC » d'office, donc qui décide si la formule est
         complète et quel prix la fiche a le droit d'annoncer. */
      syncVideoIncluse();
      if (choixGuide?.group.querySelector('input:checked')) effacerGuidage();
      /* `rendu` sert à CHIFFRER les cartes : un axe non coché y prend sa
         première valeur. `variant` est la sélection RÉELLE, et lui seul décide
         de l'achat — il reste `null` tant qu'un axe attend sa réponse. */
      const rendu = findVariant();
      const variant = variantSelectionnee();

      groups.forEach((group) => {
        const selected = group.querySelector('input:checked');
        const output = group.querySelector('[data-selected-option]');
        if (output && selected) output.textContent = selected.dataset.label || selected.value;
      });

      refreshSizeCards();
      refreshGoldCards();
      refreshVideoCards();
      refreshBinaryCards();

      /* Lot 140 — deux attentes avant tout achat, et c'est le libellé du bouton
         qui dit laquelle. Rien n'est présélectionné : tant que la taille, puis
         le niveau de perles GOLD (« Aucune GOLD supplémentaire » comprise) ne
         sont pas choisis, il n'y a pas de variante, donc pas de prix ferme et
         pas d'ajout possible. Le champ `id` est vidé ET désactivé, pour qu'un
         envoi du formulaire n'emporte jamais une variante que personne n'a
         demandée. « Combinaison indisponible », plus bas, reste réservé au cas
         où les deux axes SONT choisis sans variante correspondante. */
      if (optionsIncompletes()) {
        /* Le montant annoncé est le minimum encore atteignable compte tenu de
           TOUT ce qui est déjà choisi. Le « + » dit qu'il peut encore monter —
           il ne remplace pas un prix ferme. */
        const mini = prixMini();
        idInput.value = '';
        idInput.disabled = true;
        // An incomplete scoop can guide the customer, but cannot submit a variant.
        add.type = visibleOptions ? 'button' : 'submit';
        add.disabled = !visibleOptions;
        label.textContent = libelleAttente();
        ecrirePrix(price, mini, true);
        status.textContent = '';
        if (mobileAdd) mobileAdd.disabled = !visibleOptions;
        if (mobileAddLabel) mobileAddLabel.textContent = label.textContent;
        ecrirePrix(mobilePrice, mini, true);
        if (mobileConfig) mobileConfig.textContent = ' ';
        refreshStepSummaries(rendu);
        refreshStockMeter(null);
        const incompleteUrl = new URL(window.location.href);
        if (incompleteUrl.searchParams.has('variant')) {
          incompleteUrl.searchParams.delete('variant');
          history.replaceState(history.state, '', incompleteUrl);
        }
        /* Pas de `?variant=` : l'URL ne doit pas fabriquer une sélection que la
           cliente n'a pas faite, ni la lui renvoyer par un lien partagé. */
        return;
      }

      add.type = 'submit';
      if (!variant) {
        idInput.value = '';
        idInput.disabled = true;
        add.disabled = true;
        label.textContent = 'Combinaison indisponible';
        if (mobileAdd) mobileAdd.disabled = true;
        if (mobileAddLabel) mobileAddLabel.textContent = 'Indisponible';
        status.textContent = 'Cette combinaison n’existe pas. Choisissez une autre option.';
        /* Lot 144 — les bandeaux se referment dès qu'on y répond : leurs
           résumés doivent dire ce qui est coché même ici, sinon un bandeau
           replié annoncerait encore « Sélectionner une option » alors que la
           cliente vient de répondre. Le prix, lui, ne bouge pas : il garde son
           montant minimum et son « + », qui restent vrais tant que la variante
           n'est pas résolue — un prix ferme y serait un prix faux. */
        refreshStepSummaries(rendu);
        /* R1 (constat B) — sans cet appel, la barre mobile gardait l'ancien
           prix d'une variante qui vient de devenir indisponible. */
        refreshSticky(null);
        /* Lot 144 — et les deux prix disent la même chose : le minimum encore
           atteignable pour la taille cochée, suivi du « + ». Sans cette
           réécriture, la colonne gardait le minimum de la FICHE (relevé sur le
           Skincare : « 49,99 € » affiché après le choix de 2 scoops, dont le
           premier prix est 94,99 €) — un montant périmé, donc trop bas, ce
           qu'aucun affichage de prix n'a le droit d'être. */
        const miniIndispo = prixMini();
        ecrirePrix(price, miniIndispo, true);
        ecrirePrix(mobilePrice, miniIndispo, true);
        refreshStockMeter(null);
        return;
      }

      idInput.value = variant.id;
      idInput.disabled = false;
      ecrirePrix(price, variant.price, false);
      refreshStockMeter(variant);

      /* Média de variante (lot 125) — sans effet tant qu'aucune variante ne
         porte de `featured_media` (relevé du 4 septembre) ; s'active seule
         dès que Coralie ajoute des photos par couleur/parfum. */
      if (variant.featured_media && variant.featured_media.id) {
        activerMedia(gallery, variant.featured_media.id);
      }

      /* Lot 146 — il n'existe plus de fiche produit « vidéo » : la vidéo de
         préparation est une valeur de l'option « VIDÉO TIKTOK » du scoop
         lui-même. Lot 148 (D19) — elle est payante à toute taille, et le panier
         ne ramène plus une commande à une seule vidéo : il n'y a donc plus
         qu'une raison de bloquer l'ajout, la variante indisponible. */
      const bloque = !variant.available;
      add.hidden = false;
      add.disabled = bloque;
      if (mobileAdd) mobileAdd.disabled = bloque;
      if (!variant.available) {
        label.textContent = root.dataset.sbcSoldOutLabel || 'En rupture de stock';
        if (mobileAddLabel) mobileAddLabel.textContent = root.dataset.sbcSoldOutLabel || 'En rupture de stock';
        status.textContent = root.dataset.sbcUnavailableMessage || 'Cette formule est actuellement indisponible.';
      } else {
        label.textContent = variant.price > 0 ? `Ajouter au panier · ${money(variant.price)}` : 'Ajouter au panier';
        if (mobileAddLabel) mobileAddLabel.textContent = 'Ajouter au panier';
        status.textContent = '';
      }

      refreshStepSummaries(variant);
      refreshSticky(variant);
      const delivery = root.querySelector('[data-sbc-product-delivery]');
      if (delivery) {
        delivery.dataset.weight = String(variant.weight || 0);
        delivery.dataset.total = String(variant.price || 0);
        delivery.dispatchEvent(new CustomEvent('sbc:delivery-variant', { bubbles: true }));
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(history.state, '', url);
    };

    /* --- Ajout au panier : états du CTA, repli natif si fetch échoue ------- */
    let busy = false;
    const setBusy = (value) => {
      busy = value;
      add.setAttribute('aria-busy', String(value));
      add.disabled = value;
      if (mobileAdd) mobileAdd.disabled = value;
    };

    const submitNatively = () => {
      add.removeAttribute('aria-busy');
      form.submit();
    };

    /* Propriétés de ligne : uniquement les champs properties[...] non vides.
       Le nom Shopify properties[Préférences] reste inchangé. */
    const lineProperties = () => {
      const properties = {};
      form.querySelectorAll('[name^="properties["]').forEach((field) => {
        const key = field.name.slice(11, -1);
        const value = (field.value || '').trim();
        if (key && value) properties[key] = value;
      });
      return properties;
    };

    form.addEventListener('submit', (event) => {
      if (optionsIncompletes()) {
        event.preventDefault();
        if (visibleOptions) guiderChoixManquant();
        return;
      }
      if (busy || !variantSelectionnee()?.available || idInput.disabled || !idInput.value) {
        event.preventDefault();
        return;
      }
      if (!window.SbcPanier) return;
      event.preventDefault();
      setBusy(true);
      status.textContent = '';

      /* Lot 145 — UNE seule ligne part au panier. La vidéo n'est plus un
         second produit ajouté à côté : elle est une option de la variante
         choisie, donc elle voyage dans cette ligne-là, à son prix Shopify. */
      const lignes = [{ id: idInput.value, quantity: 1, properties: lineProperties() }];

      /* Lot 104 — l'ajout passe par le moteur unique du panier
         (`assets/sbc-panier.js`). Il sérialise la requête, réconcilie les
         cadeaux dans la foulée et publie lui-même `sbc:cart-updated` avec le
         panier final : la fiche n'a plus ni à relire `/cart.js`, ni à
         annoncer l'événement, ni à espérer qu'un wrapper l'observe. */
      window.SbcPanier.ajouter(lignes)
        .then((cart) => {
          setBusy(false);
          add.classList.add('is-done');
          const previous = label.textContent;
          label.textContent = '✓ Ajouté';
          if (mobileAddLabel) mobileAddLabel.textContent = '✓ Ajouté';
          window.setTimeout(() => {
            add.classList.remove('is-done');
            label.textContent = previous;
            if (mobileAddLabel) mobileAddLabel.textContent = 'Ajouter au panier';
          }, 1800);
        })
        .catch(() => {
          setBusy(false);
          /* Une erreur réseau ne doit pas faire perdre la configuration en
             cours. L'envoi natif rechargeait la page et, avec elle, l'option
             vidéo cochée et les préférences saisies. On garde donc la page en
             l'état et on invite à réessayer. */
          status.textContent = 'L’ajout au panier n’a pas abouti. Vérifiez votre connexion et réessayez.';
        });
    });

    if (mobileAdd) mobileAdd.addEventListener('click', () => {
      if (!add.disabled) add.click();
    });

    /* --- Étapes repliables (mobile) ---------------------------------------- */
    const steps = [...form.querySelectorAll('[data-step]')];
    /* 759px : la même bascule que la feuille (`sbc-fiche.css`), qui replie les
       étapes sous 759px. À 760px pile, le JS se croyait mobile et la CSS non. */
    const isMobile = () => window.matchMedia('(max-width: 759px)').matches;

    const compactCloseTimers = new WeakMap();
    const setStepOpen = (step, open) => {
      window.clearTimeout(compactCloseTimers.get(step));
      compactCloseTimers.delete(step);
      if (visibleOptions && !step.hasAttribute('data-sbc-compact-step')) open = true;
      step.classList.toggle('is-open', open);
      step.querySelector('[data-step-toggle]')?.setAttribute('aria-expanded', String(open));
    };

    /* Le toggle se trouve souvent en bas d'écran : ouvrir déployait 531px de
       cartes hors du viewport (12% visible, mesuré en navigateur), donnant
       l'impression que le tap n'avait rien fait. On amène donc l'étape sous
       le header une fois ouverte. */
    const revealStep = (step) => {
      if (!isMobile()) return;
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const align = () => {
        const header = document.querySelector('[data-header]');
        const headerH = header ? header.getBoundingClientRect().height : 0;
        const target = step.getBoundingClientRect().top + window.scrollY;
        /* Le header ne devient fixe qu'au-delà de 24px : on réserve sa hauteur
           dès que la cible se situe plus bas, sinon l'étape finit dessous. */
        const offset = target > 24 ? headerH + 12 : 12;
        window.scrollTo({ top: Math.max(target - offset, 0), behavior: smooth && !step.hasAttribute('data-sbc-compact-step') ? 'smooth' : 'auto' });
      };
      if (step.hasAttribute('data-sbc-compact-step')) {
        const bounds = step.getBoundingClientRect();
        const headerBottom = document.querySelector('[data-header]')?.getBoundingClientRect().bottom || 0;
        if (bounds.top < headerBottom + 12 || bounds.bottom > window.innerHeight - 24) align();
        return;
      }
      window.requestAnimationFrame(() => {
        align();
        /* Second passage : partir du haut de page fait basculer le header en
           fixe ET replier l'announcement bar pendant le défilement, ce qui
           décale la mise en page de ~99px (mesuré). On recale une fois qu'elle
           s'est stabilisée. */
        window.setTimeout(() => {
          const header = document.querySelector('[data-header]');
          const bottom = header ? header.getBoundingClientRect().bottom : 0;
          const toggle = step.querySelector('[data-step-toggle]');
          const ecart = toggle ? toggle.getBoundingClientRect().top - bottom - 12 : 0;
          if (Math.abs(ecart) > 8) align();
        }, 450);
      });
    };

    /* CTA guidance stays on the missing choice until the customer answers it.
       It never checks a radio or advances to a paid option on their behalf. */
    let choixGuide = null;
    let guidageTimer = null;
    const effacerGuidage = () => {
      window.clearTimeout(guidageTimer);
      if (!choixGuide) return;
      const { group, description, tabindex, invalid } = choixGuide;
      group.removeAttribute('data-sbc-choice-needed');
      group.querySelector('[data-sbc-choice-prompt]')?.remove();
      for (const [name, value] of [['aria-describedby', description], ['tabindex', tabindex], ['aria-invalid', invalid]]) {
        if (value === null) group.removeAttribute(name);
        else group.setAttribute(name, value);
      }
      choixGuide = null;
    };
    const guiderChoixManquant = () => {
      const group = groupeEnAttente();
      if (!visibleOptions || !group) return;
      effacerGuidage();
      const step = group.closest('[data-step]');
      if (step) setStepOpen(step, true);
      const prompt = document.createElement('p');
      prompt.id = `${form.id || 'ScoopForm'}-choice-${group.dataset.optionPosition}`;
      prompt.className = 'sbc-choice-prompt';
      prompt.setAttribute('data-sbc-choice-prompt', '');
      prompt.setAttribute('role', 'status');
      prompt.textContent = `${libelleAttente()} pour continuer.`;
      choixGuide = {
        group,
        description: group.getAttribute('aria-describedby'),
        tabindex: group.getAttribute('tabindex'),
        invalid: group.getAttribute('aria-invalid')
      };
      const legend = group.querySelector('legend');
      if (legend) legend.after(prompt);
      else group.prepend(prompt);
      group.dataset.sbcChoiceNeeded = typeDeChoix(group);
      group.setAttribute('aria-describedby', [choixGuide.description, prompt.id].filter(Boolean).join(' '));
      group.setAttribute('aria-invalid', 'true');
      group.setAttribute('tabindex', '-1');
      group.focus({ preventScroll: true });
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const align = (behavior) => {
        if (choixGuide?.group !== group || group.querySelector('input:checked')) return;
        const headerBounds = document.querySelector('[data-header]')?.getBoundingClientRect();
        const announcement = document.querySelector('.announcement');
        const announcementHeight = announcement && getComputedStyle(announcement).position === 'fixed' ? announcement.offsetHeight : 0;
        const headerOffset = Math.max((headerBounds?.height || 0) + announcementHeight, headerBounds?.bottom || 0);
        const top = group.getBoundingClientRect().top + window.scrollY - headerOffset - 24;
        window.scrollTo({ top: Math.max(0, top), behavior });
      };
      window.requestAnimationFrame(() => {
        align(reducedMotion ? 'auto' : 'smooth');
        // The sticky header changes height after leaving the top of the page.
        guidageTimer = window.setTimeout(() => align('auto'), reducedMotion ? 0 : 500);
      });
    };
    add.addEventListener('click', (event) => {
      if (!visibleOptions || !optionsIncompletes()) return;
      event.preventDefault();
      guiderChoixManquant();
    });

    steps.forEach((step) => {
      const toggle = step.querySelector('[data-step-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', () => {
        const open = !step.classList.contains('is-open');
        /* Lot 123 — l'ouverture exclusive reste un geste mobile : sur desktop les
           étapes facultatives se replient aussi, mais on peut en garder deux
           ouvertes côte à côte sans que l'une chasse l'autre. */
        if (open && (isMobile() || step.hasAttribute('data-sbc-compact-step'))) steps.forEach((other) => { if (other !== step) setStepOpen(other, false); });
        setStepOpen(step, open);
        if (open) revealStep(step);
      });
    });

    /* Lot 144 (D18) — répondre à un bandeau d'option le referme, PARTOUT.

       Jusqu'ici le repli était un geste mobile (lot 123) et l'ouverture de la
       suite nommait « taille » et « GOLD » (lot 140). Les deux sont réunis ici
       et ne nomment plus aucun axe : on referme le bandeau auquel on vient de
       répondre, puis on ouvre le PREMIER bandeau d'option encore sans réponse,
       dans l'ordre `data-option-position` — `groups` est déjà trié. Un axe
       ajouté plus tard (Vidéo, lot 145) s'y branche sans une ligne de code.

       Ce qui ne bouge pas : un bandeau déjà répondu ne se rouvre jamais —
       revenir sur la taille rabattrait un panneau que la cliente vient de
       refermer. Depuis le lot 154 (D20 point 4), « Préférences » n'est même
       plus un bandeau — bloc à plat, sans `data-step-toggle` — elle n'entre
       donc plus dans `steps` et ce mécanisme ne la voit jamais. */
    /* Regular scoops: collapse only the chosen selector, including a second
       click on its already-selected radio. Savings buttons never select a card. */
    const collapseCompactStep = (step) => {
      window.clearTimeout(compactCloseTimers.get(step));
      compactCloseTimers.set(step, window.setTimeout(() => {
        compactCloseTimers.delete(step);
        if (!step.classList.contains('is-open')) return;
        const restoreFocus = step.contains(document.activeElement);
        setStepOpen(step, false);
        if (restoreFocus) step.querySelector('[data-step-toggle]')?.focus({ preventScroll: true });
      }, 140));
    };
    form.addEventListener('click', (event) => {
      if (!event.target.matches('input.option-input[type="radio"]') || !event.target.checked) return;
      const step = event.target.closest('[data-sbc-compact-step]');
      if (step) collapseCompactStep(step);
    });
    form.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const step = event.target.closest('[data-sbc-compact-step]');
      if (!step || !step.classList.contains('is-open') || step.querySelector('[popover]:popover-open')) return;
      event.preventDefault();
      setStepOpen(step, false);
      step.querySelector('[data-step-toggle]')?.focus({ preventScroll: true });
    });

    const bandeauDe = (group) => (group ? group.closest('[data-step]') : null);
    const premierBandeauSansReponse = () => groups
      .filter((group) => !group.querySelector('input:checked'))
      .map(bandeauDe)
      .find((step) => step && step.querySelector('[data-step-toggle]')) || null;

    form.addEventListener('change', (event) => {
      if (!event.target.matches('.option-input')) return;
      const step = event.target.closest('[data-step]');
      if (step?.hasAttribute('data-sbc-compact-step')) {
        collapseCompactStep(step);
        return;
      }
      if (visibleOptions) return;
      /* Un bandeau sans axe d'option ne se referme pas : il n'a pas de réponse
         à enregistrer. */
      if (!step || !step.matches('[data-option-position]')) return;
      /* La temporisation courte (140 ms) laisse voir la carte s'activer avant
         que le panneau ne se replie. */
      window.setTimeout(() => {
        /* Le panneau qui se referme devient `display:none` : un focus resté
           dedans partirait au <body>. On note d'abord, on replace ensuite. */
        const focusDedans = step.contains(document.activeElement);
        setStepOpen(step, false);
        const suivant = premierBandeauSansReponse();
        if (suivant && !suivant.classList.contains('is-open')) {
          if (isMobile()) steps.forEach((autre) => { if (autre !== suivant) setStepOpen(autre, false); });
          setStepOpen(suivant, true);
          revealStep(suivant);
        }
        if (focusDedans) {
          const hote = (suivant && suivant.classList.contains('is-open')) ? suivant : step;
          hote.querySelector('[data-step-toggle]')?.focus();
        }
      }, 140);
    });

    /* --- Barre mobile : trois états, avec hystérésis ------------------------
       cachée  : le CTA principal est visible ;
       price   : le CTA est encore sous l'écran (configuration en cours) ;
       cta     : le CTA est passé au-dessus de l'écran.
       Les seuils d'entrée et de sortie diffèrent de 24px pour éviter tout
       clignotement au bord. */
    if (mobileBar) {
      mobileBar.hidden = false;
      let state = 'hidden';
      let frame = null;

      /* Le masquage est prioritaire, avec 40px d'anticipation : la barre
         commence à se rétracter AVANT que le CTA principal n'entre à l'écran,
         pour que sa transition soit terminée quand il devient visible. Mesuré
         en navigateur : sans cette avance, une remontée rapide laissait ~16px
         de barre visible en même temps que le haut du CTA principal.
         Les domaines restent disjoints (masquage > -40, affichage <= -64),
         donc deux « Ajouter au panier » ne peuvent jamais coexister. */
      /* Seuil PROPRE à la barre — lot 132. `isMobile()` (759px) gouverne le
         repli des étapes et doit rester synchronisé avec les media queries 759
         de `assets/sbc-fiche.css` ; la barre, elle, relaie le bouton d'achat
         jusqu'à 1023px inclus (tablette), là où le CTA réel tombe à 763px sous
         le pli. Même valeur que le `@media (max-width:1023px)` de la feuille,
         commentée des deux côtés. */
      const barreVisible = window.matchMedia('(max-width: 1023px)');

      const computeState = () => {
        if (!barreVisible.matches) return 'hidden';
        const rect = add.getBoundingClientRect();
        const viewport = window.innerHeight || document.documentElement.clientHeight;
        if (rect.bottom > -40 && rect.top < viewport) return 'hidden';
        if (rect.bottom <= -64) return 'cta';
        if (rect.top >= viewport + 24) {
          /* Rappel de prix : inutile tant que le prix principal est lui-même
             à l'écran — sinon le montant est affiché trois fois d'affilée. */
          const priceRect = price.getBoundingClientRect();
          if (priceRect.bottom > 0) return 'hidden';
          if (priceRect.bottom <= -24) return 'price';
        }
        return state;
      };

      const applyState = () => {
        frame = null;
        const next = computeState();
        if (next === state) return;
        state = next;
        mobileBar.classList.toggle('is-price', state === 'price');
        mobileBar.classList.toggle('is-cta', state === 'cta');
      };

      const requestApply = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(applyState);
      };

      window.addEventListener('scroll', requestApply, { passive: true });
      window.addEventListener('resize', requestApply, { passive: true });
      applyState();
    }

    form.addEventListener('change', (event) => {
      if (!event.target.matches('.option-input')) return;
      /* Lot 151 — un choix vidéo fait à la main se retient : c'est lui qui
         revient si la formule redevient payante, jamais une présélection. */
      if (videoGroup && videoGroup.contains(event.target)) {
        videoChoixManuel = event.target.checked ? event.target.value : '';
        videoImposee = false;
      }
      updateVariant();
    });

    /* Le panier a bougé : la fiche se relit. */
    document.addEventListener('sbc:cadeaux', () => { updateVariant(); });

    /* Un lien `?variant=` peut arriver avec une vidéo déjà cochée : c'est un
       choix de la cliente, sauf quand la formule ne laisse plus le choix — là,
       c'est le rendu serveur qui l'a posée, et la retenir comme « son » choix
       la lui rendrait plus tard sans qu'elle l'ait jamais demandée. */
    if (videoGroup && !videoIncluse()) {
      videoChoixManuel = videoGroup.querySelector('input[data-video-value]:checked')?.value || '';
    }

    updateVariant();

    /* Le média actif vient du HTML servi : seule la piste mobile reste à
       cadrer, une fois, quand ce média n'est pas le premier. */
    const indexActif = indexMediaActif(gallery);
    if (indexActif > 0) positionnerPiste(gallery, indexActif);
    if (gallery && root.dataset.productId === '11380898529607') {
      const galleryTrack = gallery.querySelector('[data-gallery-track]');
      let galleryWidth = -1;
      const alignGallery = () => {
        const width = galleryTrack?.clientWidth || 0;
        if (!width || width === galleryWidth) return;
        galleryWidth = width;
        window.requestAnimationFrame(() => {
          if (!window.matchMedia('(max-width: 759px)').matches) return;
          const activeIndex = indexMediaActif(gallery);
          if (activeIndex >= 0) positionnerPiste(gallery, activeIndex);
        });
      };
      if (typeof ResizeObserver === 'function' && galleryTrack) {
        new ResizeObserver(alignGallery).observe(galleryTrack);
      } else {
        window.addEventListener('resize', alignGallery, { passive: true });
        alignGallery();
      }
    }
  });

  /* --- Galerie : miniatures (desktop) et compteur de swipe (mobile) -------- */
  document.querySelectorAll('[data-media-target]').forEach((button) => button.addEventListener('click', () => {
    activerMedia(button.closest('[data-gallery]'), button.dataset.mediaTarget);
  }));

  document.querySelectorAll('[data-gallery-track]').forEach((track) => {
    const gallery = track.closest('[data-gallery]');
    const indexOutput = gallery?.querySelector('[data-gallery-index]');
    if (!indexOutput) return;
    let frame = null;
    track.addEventListener('scroll', () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        const width = track.clientWidth;
        if (!width) return;
        const index = Math.round(track.scrollLeft / width) + 1;
        const total = track.children.length;
        indexOutput.textContent = String(Math.min(Math.max(index, 1), total));
      });
    }, { passive: true });
  });
})();








